import axios from "axios";
import global_ from "../global/index.js"

// 获取URL参数
function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.hash.substr(window.location.hash.indexOf('?')).substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
}
if (getQueryString('sf') == 'zxkt') {
	var appId = 'wx0e382b7045a71bd6'  //在线课堂
	var mp = 'mp.wzwxpay'
} else if (getQueryString('sf') == 'zgtk') {
	var appId = 'wx4be1ac7807d664bc'  //中公题库
	var mp = ''
} else if (getQueryString('sf') == 'sydw') {
	var appId = 'wx56d3ffaa06f58ef4'  //事业单位
	var mp = 'mp.offcnxxzs'
} else if (getQueryString('sf') == 'zgzsb') {
	var appId = 'wxe50f3ebef3d642eb'  //中公专升本
	var mp = 'mp.offcnzsb'
} else if (getQueryString('sf') == 'zgyljy') {
	var appId = 'wxc4b63ebea84ff3e4'  //中公医疗教育
} else if (getQueryString('sf') == 'zgky') {
	var appId = 'wxe50f3ebef3d642eb'  //中公考研
} else {
	var appId = 'wxab6e2e44c1659bfd'  //中公教育
	var mp = 'mp.offcnkszn'
}

function getNum() {
	var chars = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'];
	var nums = "";
	for(var i=0; i<32; i++) {
		var id = parseInt(Math.random()*35);
		nums += chars[id];
	}
	return nums
}

//获得 jsapi_ticket
const wxapp = {
	initMp: function (cb, time) {
        var me = this
        if (this._hasInitMp) {
            return cb()
        }
        if (!window.wx) {
            console.log('no wx')
            return
		}
		if (getQueryString('sf') == 'zgyljy') {
			axios.get('//h5.cyikao.com/api/getticket', {
				params: {
					appid: 'youke',
					sign: 'f28b9690c7f789ec434f5895d5339e0b'
				}
			}).then(res => {
				var random_function = getNum()
				var timestamp = Math.ceil(new Date().getTime()/1000)
				var signature = 'jsapi_ticket=' + res.data.data.ticket + '&noncestr='+ random_function + '&timestamp=' + timestamp + '&url=' + window.location.href.split("/#/")[0]+'/'
				console.log(signature,sha1(signature))
				window.wx.config({
					// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					debug: false,
					// 必填，公众号的唯一标识
					appId: appId,
					// 必填，生成签名的时间戳
					timestamp: timestamp,
					// 必填，生成签名的随机串
					nonceStr: random_function,
					// 必填，签名，见附录1
					signature: sha1(signature),
					// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
					jsApiList: [
						'getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'previewImage', 'chooseWXPay', 'chooseImage', 'uploadImage', 'startRecord', 'stopRecord', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice',
						'openAddress'
					],
					openTagList: ['wx-open-launch-app']
				})
				window.wx.ready(function () {
					wx.checkJsApi({
						jsApiList: ['wx-open-launch-app'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
						success: function (res) {
						
						},
						fail: (err) => {
						
						}
					})
					// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
				});
				window.wx.error(function (res) {
					console.log("errorRes",res)
					// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
					// window.alert(JSON.stringify(res))
					me._hasInitMp = false
					console.log(res)
					if (!time) {
						time = 0
					}
					time++
					if (time > 10) {
						return
					}
					setTimeout(function () {
						me.initMp(function () {
						}, time)
					}, 1000)
				})
				me._hasInitMp = true
				cb()
			})
		} else {
			sso.use("wx",function (module) {
				module.getJsApiTicket(mp).then(function(data){
					console.log(data);
					var random_function = getNum()
					var timestamp = Math.ceil(new Date().getTime()/1000)
					var signature = 'jsapi_ticket=' + data.jsApiTicket + '&noncestr='+ random_function + '&timestamp=' + timestamp + '&url=' + window.location.href.split("/#/")[0]+'/'
					console.log(signature,sha1(signature))
					window.wx.config({
						// 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						debug: false,
						// 必填，公众号的唯一标识
						appId: appId,
						// 必填，生成签名的时间戳
						timestamp: timestamp,
						// 必填，生成签名的随机串
						nonceStr: random_function,
						// 必填，签名，见附录1
						signature: sha1(signature),
						// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
						jsApiList: [
							'getLocation', 'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone', 'previewImage', 'chooseWXPay', 'chooseImage', 'uploadImage', 'startRecord', 'stopRecord', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice',
							'openAddress'
						],
						openTagList: ['wx-open-launch-app']
					})
					window.wx.ready(function () {
						wx.checkJsApi({
							jsApiList: ['wx-open-launch-app'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
							success: function (res) {
							
							},
							fail: (err) => {
							
							}
						})
						// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
					});
					window.wx.error(function (res) {
						console.log("errorRes",res)
						// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
						// window.alert(JSON.stringify(res))
						me._hasInitMp = false
						console.log(res)
						if (!time) {
							time = 0
						}
						time++
						if (time > 10) {
							return
						}
						setTimeout(function () {
							me.initMp(function () {
							}, time)
						}, 1000)
					})
					me._hasInitMp = true
					cb()
				}).catch(function(msg){
					console.log(msg)
				})
			})
		}
		// axios.get(SERVER_BASE_URL + '/api/v2/wx/token', {
		// 	headers: user.getHeader(),
		// 	params: {
		// 		'offcn-ticket': getQueryString('ticket') || (localStorage.getItem("ticketObj") && JSON.parse(localStorage.getItem("ticketObj"))["offcn-ticket"]),
		// 		// ticket_source: JSON.parse(localStorage.getItem("ticketObj")).ticket_source,
		// 		app_id: 1,
		// 		appsystem: 'h5'
		// 	}
		// }).then(res => {
			
		// })
    },
    _hasInitMp: false,
    init: function () {
		const wx = window.wx;
        this.initMp(() => {
            wx.ready(() => {
				console.log(22222222222222222)
            })
        })
    },
	// wx.config({
	// 	debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印
	// 	appId: appId, // 必填，公众号的唯一标识
	// 	timestamp: new Date().getTime(), // 必填，生成签名的时间戳
	// 	nonceStr: getNum(), // 必填，生成签名的随机串
	// 	signature: '',// 必填，签名
	// 	jsApiList: [], // 必填，需要使用的JS接口列表
	// 	openTagList: [] // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
	// });
}
// wxapp.init()
export default wxapp;



// WEBPACK FOOTER //
// ./src/utils/wxapp.js